module.exports = __webpack_public_path__ + "media/images/carrusel/delegaciones-659f01239c9be08e5b07da57e26d39dc.jpg";